<template>
    <div>
      <Form @submit.native.prevent="preventSubmit" inline>
        <FormItem prop="dateTime" label="创建时间：" :label-width="90">
          <DatePicker type="daterange" v-model="dateTime" placeholder="选择日期" :clearable="false" class="date-time" style="width: 240px"></DatePicker>
        </FormItem>
        <FormItem prop="account" label="单据编号：" :label-width="90">
          <Input type="text" v-model="queryCriteriaRuturn.orderNo"></Input>
        </FormItem>
        <FormItem prop="account" label="归还单号：" :label-width="90">
          <Input type="text" v-model="queryCriteriaRuturn.invoiceId" style="width:200px;"></Input>
        </FormItem>
        <FormItem prop="account" label="归还人：" :label-width="90">
          <Input type="text" v-model="queryCriteriaRuturn.userName"></Input>
        </FormItem>
        <FormItem prop="account" label="归还号码：" :label-width="90">
          <Input type="text" v-model="queryCriteriaRuturn.account"></Input>
        </FormItem>
        <br>
        <FormItem prop="account" label="关联城市：" :label-width="100">
          <Input type="text" v-model="queryCriteriaRuturn.associatedCityName"></Input>
        </FormItem>
        <FormItem prop="account" label="归还中心仓：" :label-width="100">
          <Input type="text" v-model="queryCriteriaRuturn.repositoryName"></Input>
        </FormItem>
        <FormItem label="生成状态：" prop="createJxcOrderStatus" :label-width="90">
          <Select ref="register" v-model="queryCriteriaRuturn.createJxcOrderStatus" filterable style="width:150px">
            <Option :value="0">全部</Option>
            <Option :value="1">成功</Option>
            <Option :value="2">失败</Option>
            <Option :value="3">申请中</Option>
          </Select>
        </FormItem>
        <FormItem label="审批状态：" prop="approvalStatus" :label-width="90">
          <Select ref="register" v-model="queryCriteriaRuturn.approvalStatus" filterable style="width:150px">
            <Option :value="0">全部</Option>
            <Option :value="1">待审批</Option>
            <Option :value="2">审批通过</Option>
            <Option :value="3">已驳回</Option>
            <Option :value="4">已废弃</Option>
          </Select>
        </FormItem>
        <FormItem>
            <Button type="primary" @click="queryAccountListWithKeyword">查询</Button>
        </FormItem>
      </Form>
      <!-- Table-->
      <Content>
        <Table stripe :loading="false" :columns="columns" :data="materialReturnList"></Table>
        <div style="margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="listCount" :page-size="queryCriteriaRuturn.pageSize" :current="queryCriteriaRuturn.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </Content>
      <!-- Modal 查看详情-->
      <Modal v-model="materialReturnModal.display" :loading="true"  ref="materialReturnModal" title="物品详情" width="500">
        <Form @submit.native.prevent="preventSubmit" :model="materialReturnModal" :label-width="170">
          <Card dis-hover :padding='14' v-for="(item,key) in goodsTypeList" :key="key" v-if="item.materialsDetailses.length!==0">
            <p slot="title">{{item.typeName}}</p>
            <div class="card_span" v-for="(goods,key) in item.materialsDetailses" :key="key">
              <span style="border-right: 1px solid #fff;">{{`${goods.goodsName ? goods.goodsName : ''}`}}</span>
              <span>{{`${goods.goodsNum ? goods.goodsNum : 0}`}}</span>
            </div>
          </Card>
        </Form>
        <div slot="footer">
        </div>
      </Modal>
    </div>
</template>

<script>
import Moment from "moment";
import Utils from "../../../utils";
import API from "../../../api";

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.username = Utils.findFromLocalStorage("vue-username");
  },
  data() {
    return {
      // 表格数据
      materialReturnList: [],
      goodsTypeList: [],
      //    分页
      listCount: 0,
      dateTime:[
        Moment().subtract(6, 'day').format('YYYY-MM-DD'),
        Moment().format('YYYY-MM-DD')
      ],
      //查询字段
      queryCriteriaRuturn: {
        invoiceId: "",
        orderNo: "",
        userName: "",
        account: "",
        page: 1,
        pageSize: 10,
        repositoryName:'',
        beginDate:'',
        endDate:'',
        createJxcOrderStatus:0,
        approvalStatus:0,
        receiptsType:2,
        associatedCityName:''
      },
      queryParamsRuturn: {
        invoiceId: "",
        orderNo: "",
        userName: "",
        account: "",
        page: 1,
        pageSize: 10,
        repositoryName:'',
        beginDate:'',
        endDate:'',
        createJxcOrderStatus:0,
        approvalStatus:0,
        receiptsType:2,
        associatedCityName:''
      },
      // 弹窗
      materialReturnModal: {
        display: false
      },
      columns: [
        // {
        //   title: "归还id",
        //   key: "id",
        //   align: "center",
        //   width: 100,
        // },
        {
          title: "创建时间",
          key: "createDate",
          align: "center",
          width: 130,
          render:(h,p)=>{
            return h(
              'span',
               p.row.createDate ? Moment(p.row.createDate).format("YYYY-MM-DD HH:mm:ss") : ''
            )
          }
        },
        {
          title: "归还单号",
          key: "invoiceId",
          align: "center",
          width: 200,
        },
        {
          title: "单据编号",
          key: "orderNo",
          align: "center",
          width: 200,
        },
        {
          title: "归还人",
          key: "userName",
          align: "center",
          width: 100,
        },
        {
          title: "归还号码",
          key: "account",
          align: "center",
          width: 140,
        },
        {
          title: "预约归还时间",
          key: "appointmentDate",
          align: "center",
          width: 130,
          render: (h, params) => {
            const row = params.row;
            const text = row.appointmentDate ? Moment(row.appointmentDate).format("YYYY-MM-DD HH:mm:ss"):'';
            return h("Span", {}, text);
          }
        },
        {
          title: "关联城市",
          key: "associatedCityName",
          align: "center",
          width: 140,
        },
        {
          title: "归还中心仓",
          key: "repositoryName",
          align: "center",
          width: 150,
        },
        {
          title: "归还物品",
          key: "useGoods",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.materialReturnInfoModal(params.row.invoiceId);
                    }
                  }
                },
                "查看详情"
              )
            ]);
          }
        },
        {
          title: "生成状态",
          key: "createJxcOrderStatus",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h('Tag',{
                props: {
                    color: "yellow",
                    size: "small"
                  },
              },params.row.createJxcOrderStatus == 1 ? '成功' : params.row.createJxcOrderStatus == 2 ? '失败' : '申请中'),
              h('p',{},params.row.createJxcOrderStatus == 2 ? params.row.createOrderFailCause : '')
            ]);
          }
        },
        {
          title: "审批状态",
          key: "approvalStatus",
          align: "center",
          width: 100,
          render: (h, params) => {
            const statusText = ["", "待审批", "审批通过", "已驳回","已废弃"][
              params.row.approvalStatus
            ];
            return h("div", {}, statusText);
          }
        },
        {
          title: "入库时间",
          key: "outWarehouseDate",
          align: "center",
          width: 130,
          render: (h, params) => {
            const row = params.row;
            const text = row.outWarehouseDate ? Moment(row.outWarehouseDate).format("YYYY-MM-DD HH:mm:ss") :'';
            return h("Span", {}, text);
          }
        },
        {
          title: "确认时间",
          key: "storageDate",
          align: "center",
          width: 130,
          render: (h, params) => {
            const row = params.row;
            const text = row.storageDate ? Moment(row.storageDate).format("YYYY-MM-DD HH:mm:ss"):'';
            return h("Span", {}, text);
          }
        },
        {
          title: "归还状态",
          key: "recipientsState",
          align: "center",
          width: 100,
          render: (h, params) => {
            const statusList = ["", "待归还", "已归还","已失效"][
              params.row.recipientsState
            ];
            return h("div", {}, statusList);
          }
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                    disabled: params.row.recipientsState == 1 ? false : true
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: "提示",
                        content:
                          "请仔细检查已归还的物品及数量，一经确定，将无法修改！",
                        okText: "确定",
                        cancelText: "取消",
                        onOk: () => {
                          this.confirmUseModal(params.row.id);
                        }
                      });
                    }
                  }
                },
                "确定归还"
              )
            ]);
          }
        }
      ]
    };
  },
  mounted() {
    this.queryAccountList();
    this.$Notice.config({
      top: 200
    });
  },
  methods: {
    // 页面列表数据
    async queryAccountList() {
      this.queryParamsRuturn.beginDate = this.dateTime[0]? Moment(this.dateTime[0]).format("YYYY-MM-DD")
        : "";
      this.queryParamsRuturn.endDate = this.dateTime[1]
        ? Moment(this.dateTime[1]).format("YYYY-MM-DD")
        : "";
      this.queryParamsRuturn.createJxcOrderStatus = this.queryCriteriaRuturn.createJxcOrderStatus == 0 ? '' : this.queryCriteriaRuturn.createJxcOrderStatus;
      this.queryParamsRuturn.approvalStatus = this.queryCriteriaRuturn.approvalStatus == 0 ? '' : this.queryCriteriaRuturn.approvalStatus;
      let resp = (await API.omsAPI[this.env].cleaner.MmReceiptReturnList(
        this.queryParamsRuturn,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "获取列表失败",
          desc: resp.msg,
          top:30
        });
        return;
      }
      this.materialReturnList = resp.list || [];
      this.listCount = resp.totalCount;
    },
    // 查询
    queryAccountListWithKeyword() {
      this.queryParamsRuturn = Object.assign({}, this.queryCriteriaRuturn);
      this.queryAccountList();
    },
    //物资归还详情
    async materialReturnInfoModal(invoiceId) {
      let resp = (await API.omsAPI[this.env].cleaner.MmReceiptReturnGoods(
        { invoiceId: invoiceId },
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          top:30,
          desc: resp.msg
        });
      } else {
        this.goodsTypeList = resp || [];
        this.materialReturnModal.display = true;
      }
    },
    // 确定归还
    async confirmUseModal(id) {
      const params = {
        id:id,
        updateName:this.username
      }
      let resp = (await API.omsAPI[this.env].cleaner.affirmReceive(
        params,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          top:30,
          title: '归还失败',
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          top:30,
          title: '归还成功',
          desc: resp.msg
        });
      }
      this.queryAccountList();
    },
    // 分页
    changePageSize(pageSize) {
      this.queryParamsRuturn.page = 1;
      this.queryParamsRuturn.pageSize = pageSize;
      this.queryAccountList();
    },
    changePage(pageIndex) {
      this.queryParamsRuturn.page = pageIndex;
      this.queryAccountList();
    },
    preventSubmit() {
      return false;
    }
  }
};
</script>
<style lang="scss" scoped>
.card_span span {
  display: inline-block;
  width: 215px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #eee;
  border-bottom: 1px solid #fff;
}
</style>




// WEBPACK FOOTER //
// src/pages/cleaner/materialCollar-list/material-return.vue